import { render } from "./profitSharingPlan.vue?vue&type=template&id=3dc52c22&scoped=true"
import script from "./profitSharingPlan.vue?vue&type=script&lang=ts"
export * from "./profitSharingPlan.vue?vue&type=script&lang=ts"

import "./profitSharingPlan.vue?vue&type=style&index=0&id=3dc52c22&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3dc52c22"

export default script